module.exports = __webpack_public_path__ + "img/landing2.1fa6ca09.png";